module.exports = __webpack_public_path__ + "static/img/logo.ba828d1b.png";